import type { FetchAiDraftPreviewContentResponse } from '@atlassian/jira-servicedesk-knowledge-performance/src/services/fetch-ai-draft-preview-content/index.tsx';

export const FETCH_AI_DRAFT_CONTENT_SUCCESS =
	'state.actions.fetch-ai-draft-content.FETCH_AI_DRAFT_CONTENT_SUCCESS' as const;

export type FetchAIDraftContentSuccessAction = {
	type: typeof FETCH_AI_DRAFT_CONTENT_SUCCESS;
	payload: FetchAiDraftPreviewContentResponse;
};

export const fetchAIDraftContentSuccess = (
	payload: FetchAiDraftPreviewContentResponse,
): FetchAIDraftContentSuccessAction => ({
	type: FETCH_AI_DRAFT_CONTENT_SUCCESS,
	payload,
});
